const _ = require("lodash");
export const isString = (value) => {
  return typeof value === "string";
};

export const isBoolean = (value) => {
  return typeof value === "boolean";
};

export const isObject = (value) => {
  return typeof value === "object";
};

export const has = (object, key) => {
  return isObject(object) && object.hasOwnProperty(key);
};

export const get = (object, key, defaultValue) => {
  return has(object, key) ? object[key] : defaultValue;
};

export const px = (value) => {
  return `${value}px`;
};

export const translate = (x, y) => {
  return `translate(${x}, ${y})`;
};

export const roundNumber = (value, code) => {
  // if ((value % 1) != 0) value = Number(value).toFixed(2)
  if (code == "KIP") {
    return _.round(value);
  }
  return _.round(value, 2);
};

export const displayDiscount = (
  discountPercentage,
  discountAmount,
  subTotal
) => {
  try {
    if (parseFloat(discountPercentage) > 0) {
      return (subTotal * parseFloat(discountPercentage)) / 100;
    }
  } catch (e) {}

  return discountAmount;
};
